import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from "@angular/core";
import { ControlContainer, NgForm } from "@angular/forms";
import { ListOption } from "../../../../modules/tcm-core.module";
import { UserSubscriptionViewModel } from "../../../../models/users/user-subscription-view-model";
import { BaseSecureLinkedCollection } from "../../../../modules/tcm-common";

@Component({
    selector: "user-settings-subscription-linked-collection",
    templateUrl: "./user-settings-subscription-linked-collection.html",
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class UserSettingsSubscriptionLinkedCollectionComponent extends BaseSecureLinkedCollection<UserSubscriptionViewModel> implements OnDestroy {
  @Input()
  clinicInitOptions: ListOption<number>[];
  @Output()
  collectionChanged = new EventEmitter();
  constructor(){
    super();
  }
}
